import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['header', 'row']
  static values = {
    direction: { type: String, default: 'asc' },
    column: String
  }

  connect() {
    this.sortState = {}
  }

  sort(event) {
    const header = event.currentTarget
    const column = header.dataset.sort
    
    // Toggle direction if clicking same column
    if (this.sortState.column === column) {
      this.sortState.direction = this.sortState.direction === 'asc' ? 'desc' : 'asc'
    } else {
      this.sortState.column = column
      this.sortState.direction = 'asc'
    }

    // Update sort icons
    this.headerTargets.forEach(h => {
      const icon = h.querySelector('i')
      if (icon) {
        icon.setAttribute('data-lucide', 'arrow-up-down')
        icon.className = 'w-4 h-4 inline text-gray-400 ml-1'
      }
    })

    const activeIcon = header.querySelector('i')
    if (activeIcon) {
      activeIcon.setAttribute('data-lucide', this.sortState.direction === 'asc' ? 'arrow-up' : 'arrow-down')
      activeIcon.className = 'w-4 h-4 inline text-purple-600 ml-1'
    }
    if (window.lucide) window.lucide.createIcons()

    // Get rows and sort them
    const rows = Array.from(this.rowTargets)
    const sortedRows = rows.sort((a, b) => {
      const aValue = this.getCellValue(a, column)
      const bValue = this.getCellValue(b, column)
      
      if (this.sortState.direction === 'asc') {
        return this.compareValues(aValue, bValue)
      } else {
        return this.compareValues(bValue, aValue)
      }
    })

    // Re-append rows in sorted order
    const tbody = this.element.querySelector('tbody')
    sortedRows.forEach((row, index) => {
      // Update row background color for zebra striping
      row.classList.remove('bg-gray-50', 'bg-white')
      row.classList.add(index % 2 === 0 ? 'bg-gray-50' : 'bg-white')
      tbody.appendChild(row)
    })
  }

  getCellValue(row, column) {
    const cell = row.querySelector(`[data-column="${column}"]`)
    if (!cell) return ''
    
    // Get text content, trimming whitespace
    return cell.textContent.trim().toLowerCase()
  }

  compareValues(a, b) {
    // Try to parse as numbers
    const aNum = parseFloat(a)
    const bNum = parseFloat(b)
    
    if (!isNaN(aNum) && !isNaN(bNum)) {
      return aNum - bNum
    }
    
    // Try to parse as dates
    const aDate = new Date(a)
    const bDate = new Date(b)
    
    if (!isNaN(aDate.getTime()) && !isNaN(bDate.getTime())) {
      return aDate - bDate
    }
    
    // Default string comparison
    return a.localeCompare(b)
  }
}
